import { SelectChangeEvent, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import moment from "moment";
import { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ServiceContext } from "../../Contexts/ServiceContext/ServiceContext";
import { useLoading } from "../../Hooks/useLoading";
import { GLOBALS } from "../../Models/Globals";
import { IZoneFilterProps } from "./IZoneFilterProps";




export const ZoneFilter = ({

    OnSelectionChange

}: IZoneFilterProps) => {

    const { SrvContext } = useContext(ServiceContext);
    const { t, i18n } = useTranslation();
    const [isLoading, SetIsLoading] = useLoading();
    const [currentZona, setCurrentZona] = useState<string>(`${GLOBALS.NO_SELECTED_OPTION}`);


    const Initialize = async () => {

        await i18n.changeLanguage(SrvContext.WindowData.sccoDocsRender.idiomaCode);
        SetIsLoading(false);

    };

    useEffect(() => {

        Initialize();

    }, []);

    const onZoneChange = (event: SelectChangeEvent) => {

        const selectedValue = event.target.value;

        setCurrentZona(selectedValue);
        if (OnSelectionChange) {
            OnSelectionChange(selectedValue);
        }

    };


    return (
        <FormControl fullWidth>
            <InputLabel id="Zona-filter">{t('label-Zona-filter')}</InputLabel>
            <Select
                labelId="Zona-filter"
                id="Zona-filter-data"
                value={currentZona}
                onChange={onZoneChange}
            >
                <MenuItem value={GLOBALS.NO_SELECTED_OPTION}>{t('label-show-all')}</MenuItem>
                {
                    SrvContext.WindowData.sccoDocsRender.ctgZonas.map((zona, index) => (
                        <MenuItem value={zona.nombre} key={`ZonaOption-${index}`}>{zona.nombre_region} - {zona.nombre}</MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    );

};